<template>
    <div class="layout-container table-special">
        <div style="background: #ffffff;position:relative;">
            <div class="search-condition-con" :class="'show'">
                <div class="search-condition">
                    <span class="label">站点</span>
                    <div class="input-condition">
                        <site-auto-complete v-model="condition.site_id" @created="initData" :clueId=1 :owned="true"
                            :init-choose-first="false" :dataType=1 :keyType=0 ref="siteAutoComplete">
                        </site-auto-complete>
                    </div>
                </div>
                <div class="search-condition">
                    <el-button type="primary" @click="handleSearch()">查 询</el-button>
                    <el-button  @click="resetSearch()">清空条件</el-button>
                </div>
            </div>
        </div>
        <el-table :data="list" style="width: 100%" :highlight-current-row="true" border tooltip-effect="dark"
            ref="multipleTable" v-loading="isLoading" header-cell-class-name="table-back" class="list-table">
            <el-table-column label="站点" prop="site_name" align="center">
                <template slot-scope="scope">
                    <p class="ellips" :title="scope.row.site_name">{{ scope.row.site_name }}</p>
                </template>
            </el-table-column>
            <el-table-column label="创建预览时间" prop="created_at" align="center"></el-table-column>
            <el-table-column label="创建人" prop="operator" width="100" align="center"></el-table-column>
            <el-table-column label="预估生成量" prop="create_num" width="100" align="center">
                <template slot-scope="scope">
                    <span v-if="scope.row.status == 1">{{scope.row.status_text}}</span>
                    <span v-else>{{scope.row.create_num}}</span>
                </template>
            </el-table-column>
            <el-table-column label="操作" width="300px" align="center">
                <template slot-scope="scope">
                    <el-button type="text" size="mini" @click="openPreview(scope.row.id)">查看预览</el-button>
                    <el-button type="text" size="mini" @click="handleDelete(scope.row.id)">删除</el-button>
                </template>
            </el-table-column>
        </el-table>
        <template v-if="list.length > 0">
            <el-pagination background layout="total,prev, pager, next" :current-page="condition.page"
                :total="condition.total" :page-size="condition.per_page" @current-change="currentChange">
            </el-pagination>
        </template>
        <preview-detail ref="previewDetailRef" :preDetail="preDetail" :callback="initData" />
    </div>
</template>
<style>
td a:link {
    color: #606266;
}

td a:visited {
    color: #606266;
}
</style>
<script>
import { getTopicModelList, terminationTask } from '@/service/topicBank'
import { getSite } from "@/service/site";
import previewDetail from './previewDetail';
import SiteAutoComplete from "@/components/auto-complete/site-auto-complete";
import {getRecordPreList,recordPreviewsDetail,deleteRecordPreviews} from '@/service/topicBank'

export default {
    components: { previewDetail, SiteAutoComplete },
    name: "List",
    data() {
        return {
            list: [],
            condition: {
                site_id: '',
                total: 0,
                per_page: 10,
                page: 1,
            },
            isLoading: false,
            preDetail:{}
        }
    },
    mounted() {
        this.initData();

    },
    methods: {

        handleSearch() {
            this.condition.page = 1
            this.initData();
        },
        resetSearch() {
            this.condition = {
                site_id: '',
                total: 0,
                per_page: 10,
                page: 1,
            }
            this.initData();
        },

        openPreview(id) {
            recordPreviewsDetail(id).then((res) => {
                this.preDetail = res;
                this.$refs.previewDetailRef && this.$refs.previewDetailRef.openMenu()

            }).catch(err => {
                this.$message({
                    message: err.message || '查看失败',
                    type: 'error',
                    duration: 3 * 1000
                })
            })
        },
        currentChange(index) {
            this.condition.page = index;
            this.initData();
        },
        async initData() {
            this.list = []
            if(this.condition.site_id == 0){
                this.condition.site_id = ''
            }
            await getRecordPreList(this.condition).then((data) => {
                this.condition.total = data.total
                this.list = data.data
            })
            this.isLoading = false
        },
        handleDelete(id) {
            this.$confirm("是否删除此条预览情况？", "删除", {
                confirmButtonText: "确定",
                cancelButtonText: "取消",
                type: "warning"
            }).then(() => {
                deleteRecordPreviews(id).then(res => {
                    this.$message({
                        message: '删除成功',
                        type: 'success',
                        duration: 3 * 1000
                    })
                    this.initData();
                }).catch(err => {
                    this.$message({
                        message: err.message || '删除失败',
                        type: 'error',
                        duration: 3 * 1000
                    })
                })
            });
        },
    }
}
</script>

<style scoped>
.list-table {
    box-sizing: border-box;
}

.baikeCat .el-select {
    width: 48%;
    float: left;
}

.ellips {
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
}
</style>



















